<template>
  <div v-if="type !== -1" class="type-wrap">
    <img :src="pic" :class="isSelf ? 'h-[22px]' : 'h-[19px]'" />
  </div>
</template>

<script setup lang="ts">
import type0cn from '../img/type/tag-cn-00.png';
import type1cn from '../img/type/tag-cn-01.png';
import type2cn from '../img/type/tag-cn-02.png';
import type3cn from '../img/type/tag-cn-03.png';
import type4cn from '../img/type/tag-cn-04.png';
import type5cn from '../img/type/tag-cn-05.png';
import type0en from '../img/type/tag-en-00.png';
import type1en from '../img/type/tag-en-01.png';
import type2en from '../img/type/tag-en-02.png';
import type3en from '../img/type/tag-en-03.png';
import type4en from '../img/type/tag-en-04.png';
import type5en from '../img/type/tag-en-05.png';

const props = withDefaults(defineProps<{
  isSelf?: boolean
  //type: 0-单牌 1-对子 2-顺子 3-同花 4-同花顺 5-三条
  type?: number
}>(), {
  type: 0
})
const $i18n = useNuxtApp().$i18n;
const sLang = computed(()=>{
    return $i18n.locale.value;
});
const piccfg = {
  type0cn, type1cn, type2cn,type3cn, type4cn, type5cn,
  type0en, type1en, type2en, type3en, type4en, type5en,
}

const pic = computed(()=>{
  return piccfg[`type${props.type}${sLang.value}`]
})
</script>

<style lang="scss" scoped>
.type-wrap {
  position: absolute;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;

  img {
    object-fit: contain;
  }
}
</style>